import { FEATURE_FLAGS } from '@/constants';

const isV2 = FEATURE_FLAGS.ENABLE_SCORECARD_V2;

/**
 * ViolationSvg component.
 *
 * This component renders an SVG icon representing a violation. It is designed to be used in
 * various parts of the application where a visual representation of a violation is needed. The
 * SVG is styled using CSS variables, allowing for easy customization of its color and appearance.
 *
 * The component is defined as a functional component and uses the `displayName` property for
 * better debugging and readability in React DevTools. It is exported as the default export,
 * making it easy to import and use in other parts of the application.
 */
export const ViolationSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    aria-label="Violation visualization"
    fill="none"
    height="34"
    role="img"
    viewBox="0 0 34 34"
    width="34"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill={isV2 ? 'var(--color-accent-border-yellow)' : 'var(--color-accent-red-500)'}
      d="M31.2556 15.5009L18.4989 2.74293C18.1008 2.34715 17.5622 2.125 17.0008 2.125C16.4394 2.125 15.9008 2.34715 15.5027 2.74293L2.7527 15.5009C2.35692 15.899 2.13477 16.4376 2.13477 16.999C2.13477 17.5604 2.35692 18.099 2.7527 18.4972L15.5093 31.2551C15.9075 31.6509 16.4461 31.8731 17.0075 31.8731C17.5689 31.8731 18.1074 31.6509 18.5056 31.2551L31.2622 18.4972C31.658 18.099 31.8802 17.5604 31.8802 16.999C31.8802 16.4376 31.658 15.899 31.2622 15.5009H31.2556ZM15.9383 10.624C15.9383 10.3422 16.0503 10.072 16.2495 9.87273C16.4488 9.67347 16.719 9.56153 17.0008 9.56153C17.2826 9.56153 17.5529 9.67347 17.7521 9.87273C17.9514 10.072 18.0633 10.3422 18.0633 10.624V18.0615C18.0633 18.3433 17.9514 18.6136 17.7521 18.8128C17.5529 19.0121 17.2826 19.124 17.0008 19.124C16.719 19.124 16.4488 19.0121 16.2495 18.8128C16.0503 18.6136 15.9383 18.3433 15.9383 18.0615V10.624ZM17.0008 24.4365C16.6856 24.4365 16.3775 24.3431 16.1154 24.1679C15.8533 23.9928 15.649 23.7439 15.5284 23.4527C15.4078 23.1615 15.3762 22.841 15.4377 22.5319C15.4992 22.2227 15.651 21.9387 15.8739 21.7158C16.0968 21.4929 16.3807 21.3411 16.6899 21.2797C16.9991 21.2182 17.3195 21.2497 17.6107 21.3703C17.9019 21.491 18.1509 21.6952 18.326 21.9573C18.5011 22.2194 18.5946 22.5276 18.5946 22.8428C18.5946 23.2655 18.4267 23.6708 18.1278 23.9697C17.8289 24.2686 17.4235 24.4365 17.0008 24.4365Z"
    />
  </svg>
);

ViolationSvg.displayName = 'ViolationSvg';

export default ViolationSvg;
